import React from "react";
import { arrayOf, bool, shape, string } from "prop-types";
import PageNavbar from "@insightfulscience/atomic-react/PageNavbar";
import { LinkBlock } from "./Link";

const LinksBlock = ({ linkReference, stickyToc = false }) => {
	return (
		<PageNavbar
			alignHorizontal="around"
			fullWidthBorder
			utility={{ bgColor: "white" }}
			sticky={stickyToc}
		>
			{linkReference.map(({ fields }) => (
				<LinkBlock key={fields.linkUrl} {...fields} />
			))}
		</PageNavbar>
	);
};

LinksBlock.propTypes = {
	stickyToc: bool,
	linkReference: arrayOf(
		shape({
			fields: shape({
				linkText: string.isRequired,
				linkUrl: string.isRequired,
			}),
		}),
	),
};

export default LinksBlock;
